import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18","key":"svg-0"}],["path",{"d":"M9 10h-.01","key":"svg-1"}],["path",{"d":"M15 10h-.01","key":"svg-2"}],["path",{"d":"M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1","key":"svg-3"}]]

const IconMoodSick = createReactComponent('outline', 'mood-sick', 'MoodSick', __iconNode);

export default IconMoodSick;